import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3cab3516"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-container" }
const _hoisted_2 = {
  class: "dashboard-section",
  style: {"flex":"1"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "广告账户数据")
], -1))
const _hoisted_4 = { class: "stat-card" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "总广告账户数", -1))
const _hoisted_6 = { class: "stat-value" }
const _hoisted_7 = { class: "stat-card" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "今日新增广告账户数", -1))
const _hoisted_9 = { class: "stat-value stat-value-success" }
const _hoisted_10 = { class: "stat-card" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "昨日新增广告账户数", -1))
const _hoisted_12 = { class: "stat-value stat-value-success" }
const _hoisted_13 = { class: "stat-card" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "本周新增广告账户数", -1))
const _hoisted_15 = { class: "stat-value stat-value-success" }
const _hoisted_16 = { class: "stat-card" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "本月新增广告账户数", -1))
const _hoisted_18 = { class: "stat-value stat-value-success" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"12px"} }, null, -1))
const _hoisted_20 = { class: "stat-card" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "累计消耗总金额", -1))
const _hoisted_22 = { class: "stat-value stat-value-primary" }
const _hoisted_23 = { class: "stat-card" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "本年累计消耗总金额", -1))
const _hoisted_25 = { class: "stat-value" }
const _hoisted_26 = { class: "stat-card" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "本月累计消耗总金额", -1))
const _hoisted_28 = { class: "stat-value stat-value-success" }
const _hoisted_29 = { class: "stat-card" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "本周累计消耗总金额", -1))
const _hoisted_31 = { class: "stat-value" }
const _hoisted_32 = { class: "stat-card" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "昨日账户消耗总金额", -1))
const _hoisted_34 = { class: "stat-value" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"12px"} }, null, -1))
const _hoisted_36 = { class: "stat-card" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "有消耗记录总账户数", -1))
const _hoisted_38 = { class: "stat-value" }
const _hoisted_39 = { class: "stat-card" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "昨日启动消耗账户数", -1))
const _hoisted_41 = { class: "stat-card" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "本月启动消耗账户数", -1))
const _hoisted_43 = { class: "stat-card" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "昨日封禁账户数", -1))
const _hoisted_45 = { class: "stat-value stat-value-success" }
const _hoisted_46 = { class: "stat-card" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "本月封禁账户数", -1))
const _hoisted_48 = { class: "stat-value stat-value-success" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "subsection-title",
  style: {"margin-top":"16px"}
}, "时区分类数据", -1))
const _hoisted_50 = { class: "stat-card gmt-total-card" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "总时区数", -1))
const _hoisted_52 = { class: "stat-value stat-value-primary" }
const _hoisted_53 = { class: "stat-card gmt-detail-card" }
const _hoisted_54 = { class: "gmt-card-header" }
const _hoisted_55 = { class: "gmt-name" }
const _hoisted_56 = { class: "gmt-ban-rate" }
const _hoisted_57 = { class: "gmt-card-body" }
const _hoisted_58 = { class: "gmt-stat-line" }
const _hoisted_59 = { class: "gmt-stat-line" }
const _hoisted_60 = { class: "gmt-stat-line" }
const _hoisted_61 = { class: "gmt-stat-line" }
const _hoisted_62 = { class: "gmt-stat-line" }
const _hoisted_63 = { class: "gmt-stat-line" }
const _hoisted_64 = { class: "gmt-stat-line" }
const _hoisted_65 = {
  key: 0,
  class: "gmt-expand-wrap"
}
const _hoisted_66 = { class: "stat-card stat-card-label" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "请选择客户", -1))
const _hoisted_68 = { class: "stat-card" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "累计充值金额", -1))
const _hoisted_70 = { class: "stat-value stat-value-success" }
const _hoisted_71 = { class: "stat-card" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "累计消耗金额", -1))
const _hoisted_73 = { class: "stat-value stat-value-success" }
const _hoisted_74 = { class: "stat-card" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "本月消耗金额", -1))
const _hoisted_76 = { class: "stat-value stat-value-success" }
const _hoisted_77 = { class: "stat-card" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "昨日消耗金额", -1))
const _hoisted_79 = { class: "stat-value stat-value-success" }
const _hoisted_80 = {
  class: "dashboard-section",
  style: {"flex":"1"}
}
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "客户数量数据")
], -1))
const _hoisted_82 = { class: "stat-card" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "累计充值", -1))
const _hoisted_84 = { class: "stat-value stat-value-success" }
const _hoisted_85 = { class: "stat-sub-value" }
const _hoisted_86 = { class: "sub-label sub-label-inner" }
const _hoisted_87 = { class: "sub-label sub-label-outer" }
const _hoisted_88 = { class: "stat-card" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "客户总广告账户数", -1))
const _hoisted_90 = { class: "stat-value stat-value-primary" }
const _hoisted_91 = { class: "stat-sub-value" }
const _hoisted_92 = { class: "sub-label sub-label-inner" }
const _hoisted_93 = { class: "sub-label sub-label-outer" }
const _hoisted_94 = { class: "stat-card" }
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "总客户数量", -1))
const _hoisted_96 = { class: "stat-value" }
const _hoisted_97 = { class: "stat-sub-value" }
const _hoisted_98 = { class: "sub-label sub-label-inner" }
const _hoisted_99 = { class: "sub-label sub-label-outer" }
const _hoisted_100 = { class: "stat-card" }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "已充值客户数量", -1))
const _hoisted_102 = { class: "stat-value stat-value-primary" }
const _hoisted_103 = { class: "stat-sub-value" }
const _hoisted_104 = { class: "sub-label sub-label-inner" }
const _hoisted_105 = { class: "sub-label sub-label-outer" }
const _hoisted_106 = { class: "stat-card" }
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "本月新增客户数量", -1))
const _hoisted_108 = { class: "stat-value stat-value-success" }
const _hoisted_109 = { class: "stat-sub-value" }
const _hoisted_110 = { class: "sub-label sub-label-inner" }
const _hoisted_111 = { class: "sub-label sub-label-outer" }
const _hoisted_112 = { class: "stat-card" }
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "本周新增客户数量", -1))
const _hoisted_114 = { class: "stat-value stat-value-success" }
const _hoisted_115 = { class: "stat-sub-value" }
const _hoisted_116 = { class: "sub-label sub-label-inner" }
const _hoisted_117 = { class: "sub-label sub-label-outer" }
const _hoisted_118 = { class: "dashboard-section" }
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "账户数据分析")
], -1))
const _hoisted_120 = { class: "pie-charts-container" }
const _hoisted_121 = { class: "pie-chart-item" }
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "chart-title" }, "账户分配统计", -1))
const _hoisted_123 = {
  ref: "accountChartRef",
  class: "banned-chart"
}
const _hoisted_124 = { class: "pie-chart-item" }
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "chart-title" }, "封禁数据统计", -1))
const _hoisted_126 = {
  ref: "bannedChartRef",
  class: "banned-chart"
}
const _hoisted_127 = { class: "pie-chart-item" }
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "chart-title" }, "使用中时区统计", -1))
const _hoisted_129 = {
  ref: "gmtPieChartRef",
  class: "banned-chart"
}
const _hoisted_130 = {
  class: "dashboard-section",
  style: {"margin-top":"0px"}
}
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "消耗数据")
], -1))
const _hoisted_132 = { class: "stat-card" }
const _hoisted_133 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "累计消耗金额 (账户维度)", -1))
const _hoisted_134 = { class: "stat-value stat-value-primary" }
const _hoisted_135 = { class: "stat-sub-value" }
const _hoisted_136 = { class: "sub-label sub-label-inner" }
const _hoisted_137 = { class: "sub-label sub-label-outer" }
const _hoisted_138 = { class: "stat-card" }
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "可用账户数", -1))
const _hoisted_140 = { class: "stat-value" }
const _hoisted_141 = { class: "stat-sub-value" }
const _hoisted_142 = { class: "sub-label sub-label-inner" }
const _hoisted_143 = { class: "sub-label sub-label-outer" }
const _hoisted_144 = { class: "stat-card" }
const _hoisted_145 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "昨日有消耗账户数", -1))
const _hoisted_146 = { class: "stat-value" }
const _hoisted_147 = { class: "stat-sub-value" }
const _hoisted_148 = { class: "sub-label sub-label-inner" }
const _hoisted_149 = { class: "sub-label sub-label-outer" }
const _hoisted_150 = { class: "chart-section" }
const _hoisted_151 = {
  ref: "expendChartRef",
  class: "expend-chart"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_DownOutlined = _resolveComponent("DownOutlined")!
  const _component_UpOutlined = _resolveComponent("UpOutlined")!
  const _component_UserSelect = _resolveComponent("UserSelect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_row, { gutter: 12 }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, {
          xs: 24,
          lg: 18,
          style: {"display":"flex","flex-direction":"column"}
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createVNode(_component_a_row, {
                gutter: [12, 12],
                class: "account-stats-row"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    xs: 24,
                    sm: 12,
                    md: 8,
                    lg: 5,
                    xl: 5
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, [
                        _hoisted_5,
                        _createElementVNode("div", _hoisted_6, _toDisplayString($setup.animatedAccountData.totalAds || 0), 1)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    xs: 24,
                    sm: 12,
                    md: 8,
                    lg: 5,
                    xl: 5
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_7, [
                        _hoisted_8,
                        _createElementVNode("div", _hoisted_9, _toDisplayString($setup.animatedAccountData.todayNewAds || 0), 1)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    xs: 24,
                    sm: 12,
                    md: 8,
                    lg: 5,
                    xl: 5
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_10, [
                        _hoisted_11,
                        _createElementVNode("div", _hoisted_12, _toDisplayString($setup.animatedAccountData.yesterdayNewAds || 0), 1)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    xs: 24,
                    sm: 12,
                    md: 8,
                    lg: 5,
                    xl: 5
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_13, [
                        _hoisted_14,
                        _createElementVNode("div", _hoisted_15, _toDisplayString($setup.animatedAccountData.weekNewAds || 0), 1)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    xs: 24,
                    sm: 12,
                    md: 8,
                    lg: 5,
                    xl: 5
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_16, [
                        _hoisted_17,
                        _createElementVNode("div", _hoisted_18, _toDisplayString($setup.animatedAccountData.monthNewAds || 0), 1)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _hoisted_19,
              _createVNode(_component_a_row, {
                gutter: [12, 12],
                class: "account-stats-row"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    xs: 24,
                    sm: 12,
                    md: 8,
                    lg: 4,
                    xl: 4
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_20, [
                        _hoisted_21,
                        _createElementVNode("div", _hoisted_22, " $" + _toDisplayString($setup.formatMoney($setup.animatedExpendData.totalExpend)), 1)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    xs: 24,
                    sm: 12,
                    md: 8,
                    lg: 4,
                    xl: 4
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_23, [
                        _hoisted_24,
                        _createElementVNode("div", _hoisted_25, " $" + _toDisplayString($setup.formatMoney($setup.animatedExpendData.yearExpend)), 1)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    xs: 24,
                    sm: 12,
                    md: 8,
                    lg: 4,
                    xl: 4
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_26, [
                        _hoisted_27,
                        _createElementVNode("div", _hoisted_28, " $" + _toDisplayString($setup.formatMoney($setup.animatedExpendData.monthExpend)), 1)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    xs: 24,
                    sm: 12,
                    md: 8,
                    lg: 4,
                    xl: 4
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_29, [
                        _hoisted_30,
                        _createElementVNode("div", _hoisted_31, " $" + _toDisplayString($setup.formatMoney($setup.animatedExpendData.weekExpend)), 1)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    xs: 24,
                    sm: 12,
                    md: 8,
                    lg: 4,
                    xl: 4
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_32, [
                        _hoisted_33,
                        _createElementVNode("div", _hoisted_34, " $" + _toDisplayString($setup.formatMoney($setup.animatedExpendData.yesterdayExpend)), 1)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _hoisted_35,
              _createVNode(_component_a_row, {
                gutter: [12, 12],
                class: "account-stats-row"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    xs: 24,
                    sm: 12,
                    md: 8,
                    lg: 4,
                    xl: 4
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_36, [
                        _hoisted_37,
                        _createElementVNode("div", _hoisted_38, _toDisplayString($setup.accountExpendData.expendCount), 1)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    xs: 24,
                    sm: 12,
                    md: 8,
                    lg: 4,
                    xl: 4
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_39, [
                        _hoisted_40,
                        _createElementVNode("div", {
                          class: _normalizeClass(["stat-value", { 'stat-value-success': $setup.accountExpendData.yesterdayStartCount === 0 }])
                        }, _toDisplayString($setup.accountExpendData.yesterdayStartCount), 3)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    xs: 24,
                    sm: 12,
                    md: 8,
                    lg: 4,
                    xl: 4
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_41, [
                        _hoisted_42,
                        _createElementVNode("div", {
                          class: _normalizeClass(["stat-value", { 'stat-value-success': $setup.accountExpendData.monthStartCount === 0 }])
                        }, _toDisplayString($setup.accountExpendData.monthStartCount), 3)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    xs: 24,
                    sm: 12,
                    md: 8,
                    lg: 4,
                    xl: 4
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_43, [
                        _hoisted_44,
                        _createElementVNode("div", _hoisted_45, _toDisplayString($setup.accountExpendData.yesterdayBannedCount), 1)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    xs: 24,
                    sm: 12,
                    md: 8,
                    lg: 4,
                    xl: 4
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_46, [
                        _hoisted_47,
                        _createElementVNode("div", _hoisted_48, _toDisplayString($setup.accountExpendData.monthBannedCount), 1)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _hoisted_49,
              _createVNode(_component_a_row, {
                gutter: [12, 12],
                class: "gmt-stats-row"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    xs: 24,
                    sm: 12,
                    md: 6,
                    lg: 6,
                    xl: 6
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_50, [
                        _hoisted_51,
                        _createElementVNode("div", _hoisted_52, _toDisplayString($setup.gmtTotalCount), 1)
                      ])
                    ]),
                    _: 1
                  }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.gmtDisplayList, (item, index) => {
                    return (_openBlock(), _createBlock(_component_a_col, {
                      key: item.gmt || index,
                      xs: 24,
                      sm: 12,
                      md: 6,
                      lg: 6,
                      xl: 6
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_53, [
                          _createElementVNode("div", _hoisted_54, [
                            _createElementVNode("span", _hoisted_55, _toDisplayString($setup.formatGmtLabel(item.gmt)), 1),
                            _createElementVNode("span", _hoisted_56, "封户率: " + _toDisplayString($setup.getBanRate(item)) + "%", 1)
                          ]),
                          _createElementVNode("div", _hoisted_57, [
                            _createElementVNode("div", _hoisted_58, "累计 " + _toDisplayString(item.totalCount), 1),
                            _createElementVNode("div", _hoisted_59, "在用 " + _toDisplayString(item.usingCount), 1),
                            _createElementVNode("div", _hoisted_60, "可用 " + _toDisplayString(item.availableCount), 1),
                            _createElementVNode("div", _hoisted_61, "昨日创建 " + _toDisplayString(item.yesterdayCreateCount), 1),
                            _createElementVNode("div", _hoisted_62, "本月创建 " + _toDisplayString(item.monthCreateCount), 1),
                            _createElementVNode("div", _hoisted_63, "累计消耗金额 $" + _toDisplayString($setup.formatMoney(item.totalExpend)), 1),
                            _createElementVNode("div", _hoisted_64, "单户平均消耗金额 $" + _toDisplayString($setup.formatMoney($setup.getGmtAvgExpend(item))), 1)
                          ])
                        ])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }),
              ($setup.gmtHasMore)
                ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                    _createElementVNode("a", {
                      class: "gmt-expand-btn",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.gmtExpanded = !$setup.gmtExpanded))
                    }, [
                      _createElementVNode("span", null, _toDisplayString($setup.gmtExpanded ? '收起' : '展开'), 1),
                      (!$setup.gmtExpanded)
                        ? (_openBlock(), _createBlock(_component_DownOutlined, {
                            key: 0,
                            class: "gmt-expand-icon"
                          }))
                        : (_openBlock(), _createBlock(_component_UpOutlined, {
                            key: 1,
                            class: "gmt-expand-icon"
                          }))
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_a_row, {
                gutter: 12,
                class: "customer-stats-row customer-stats-row-5",
                style: {"margin-top":"16px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { class: "customer-stats-col-5" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_66, [
                        _hoisted_67,
                        _createVNode(_component_UserSelect, {
                          modelValue: $setup.customerUserId,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.customerUserId) = $event)),
                          placeholder: "请选择客户",
                          "allow-all": "",
                          onChange: $setup.onCustomerUserChange
                        }, null, 8, ["modelValue", "onChange"])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { class: "customer-stats-col-5" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_68, [
                        _hoisted_69,
                        _createElementVNode("div", _hoisted_70, " $" + _toDisplayString($setup.formatMoney($setup.customerStats.totalRecharge)), 1)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { class: "customer-stats-col-5" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_71, [
                        _hoisted_72,
                        _createElementVNode("div", _hoisted_73, " $" + _toDisplayString($setup.formatMoney($setup.customerStats.totalExpend)), 1)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { class: "customer-stats-col-5" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_74, [
                        _hoisted_75,
                        _createElementVNode("div", _hoisted_76, " $" + _toDisplayString($setup.formatMoney($setup.customerStats.monthExpend)), 1)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { class: "customer-stats-col-5" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_77, [
                        _hoisted_78,
                        _createElementVNode("div", _hoisted_79, " $" + _toDisplayString($setup.formatMoney($setup.customerStats.yesterdayExpend)), 1)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, {
          xs: 24,
          lg: 6,
          style: {"display":"flex","flex-direction":"column"}
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_80, [
              _hoisted_81,
              _createVNode(_component_a_row, { gutter: [12, 12] }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    xs: 24,
                    sm: 12,
                    md: 12,
                    lg: 24,
                    xl: 24
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_82, [
                        _hoisted_83,
                        _createElementVNode("div", _hoisted_84, " $" + _toDisplayString($setup.formatMoney($setup.animatedExpendData.totalRecharge)), 1),
                        _createElementVNode("div", _hoisted_85, [
                          _createElementVNode("span", _hoisted_86, "内部: $" + _toDisplayString($setup.formatMoney($setup.animatedExpendData.innerTotalRecharge)), 1),
                          _createElementVNode("span", _hoisted_87, "外部: $" + _toDisplayString($setup.formatMoney($setup.animatedExpendData.outerTotalRecharge)), 1)
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    xs: 24,
                    sm: 12,
                    md: 12,
                    lg: 24,
                    xl: 24
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_88, [
                        _hoisted_89,
                        _createElementVNode("div", _hoisted_90, _toDisplayString($setup.animatedExpendData.totalAdsAccounts || 0), 1),
                        _createElementVNode("div", _hoisted_91, [
                          _createElementVNode("span", _hoisted_92, "内部: " + _toDisplayString($setup.animatedExpendData.innerTotalAdsAccounts || 0), 1),
                          _createElementVNode("span", _hoisted_93, "外部: " + _toDisplayString($setup.animatedExpendData.outerTotalAdsAccounts || 0), 1)
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    xs: 24,
                    sm: 12,
                    md: 12,
                    lg: 24,
                    xl: 24
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_94, [
                        _hoisted_95,
                        _createElementVNode("div", _hoisted_96, _toDisplayString($setup.animatedUserData.totalUsers || 0), 1),
                        _createElementVNode("div", _hoisted_97, [
                          _createElementVNode("span", _hoisted_98, "内部: " + _toDisplayString($setup.animatedUserData.innerTotalUsers || 0), 1),
                          _createElementVNode("span", _hoisted_99, "外部: " + _toDisplayString($setup.animatedUserData.outerTotalUsers || 0), 1)
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    xs: 24,
                    sm: 12,
                    md: 12,
                    lg: 24,
                    xl: 24
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_100, [
                        _hoisted_101,
                        _createElementVNode("div", _hoisted_102, _toDisplayString($setup.animatedUserData.paidUsers || 0), 1),
                        _createElementVNode("div", _hoisted_103, [
                          _createElementVNode("span", _hoisted_104, "内部: " + _toDisplayString($setup.animatedUserData.innerPaidUsers || 0), 1),
                          _createElementVNode("span", _hoisted_105, "外部: " + _toDisplayString($setup.animatedUserData.outerPaidUsers || 0), 1)
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    xs: 24,
                    sm: 12,
                    md: 12,
                    lg: 24,
                    xl: 24
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_106, [
                        _hoisted_107,
                        _createElementVNode("div", _hoisted_108, _toDisplayString($setup.animatedUserData.monthNewUsers || 0), 1),
                        _createElementVNode("div", _hoisted_109, [
                          _createElementVNode("span", _hoisted_110, "内部: " + _toDisplayString($setup.animatedUserData.innerMonthNewUsers || 0), 1),
                          _createElementVNode("span", _hoisted_111, "外部: " + _toDisplayString($setup.animatedUserData.outerMonthNewUsers || 0), 1)
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    xs: 24,
                    sm: 12,
                    md: 12,
                    lg: 24,
                    xl: 24
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_112, [
                        _hoisted_113,
                        _createElementVNode("div", _hoisted_114, _toDisplayString($setup.animatedUserData.weekNewUsers || 0), 1),
                        _createElementVNode("div", _hoisted_115, [
                          _createElementVNode("span", _hoisted_116, "内部: " + _toDisplayString($setup.animatedUserData.innerWeekNewUsers || 0), 1),
                          _createElementVNode("span", _hoisted_117, "外部: " + _toDisplayString($setup.animatedUserData.outerWeekNewUsers || 0), 1)
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_118, [
      _hoisted_119,
      _createElementVNode("div", _hoisted_120, [
        _createElementVNode("div", _hoisted_121, [
          _hoisted_122,
          _createElementVNode("div", _hoisted_123, null, 512)
        ]),
        _createElementVNode("div", _hoisted_124, [
          _hoisted_125,
          _createElementVNode("div", _hoisted_126, null, 512)
        ]),
        _createElementVNode("div", _hoisted_127, [
          _hoisted_128,
          _createElementVNode("div", _hoisted_129, null, 512)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_130, [
      _hoisted_131,
      _createVNode(_component_a_row, {
        gutter: [12, 12],
        style: {"margin-top":"16px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, {
            xs: 24,
            sm: 12,
            md: 8,
            lg: 6,
            xl: 6
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_132, [
                _hoisted_133,
                _createElementVNode("div", _hoisted_134, " $" + _toDisplayString($setup.formatMoney($setup.animatedExpendData.totalAccountExpend)), 1),
                _createElementVNode("div", _hoisted_135, [
                  _createElementVNode("span", _hoisted_136, "内部: $" + _toDisplayString($setup.formatMoney($setup.animatedExpendData.innerTotalAccountExpend)), 1),
                  _createElementVNode("span", _hoisted_137, "外部: $" + _toDisplayString($setup.formatMoney($setup.animatedExpendData.outerTotalAccountExpend)), 1)
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_a_col, {
            xs: 24,
            sm: 12,
            md: 8,
            lg: 6,
            xl: 6
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_138, [
                _hoisted_139,
                _createElementVNode("div", _hoisted_140, _toDisplayString($setup.animatedExpendData.availableAdsAccounts || 0), 1),
                _createElementVNode("div", _hoisted_141, [
                  _createElementVNode("span", _hoisted_142, "内部: " + _toDisplayString($setup.animatedExpendData.innerAvailableAdsAccounts || 0), 1),
                  _createElementVNode("span", _hoisted_143, "外部: " + _toDisplayString($setup.animatedExpendData.outerAvailableAdsAccounts || 0), 1)
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_a_col, {
            xs: 24,
            sm: 12,
            md: 8,
            lg: 6,
            xl: 6
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_144, [
                _hoisted_145,
                _createElementVNode("div", _hoisted_146, _toDisplayString($setup.animatedExpendData.yesterdayExpendAccountCount || 0), 1),
                _createElementVNode("div", _hoisted_147, [
                  _createElementVNode("span", _hoisted_148, "内部: " + _toDisplayString($setup.animatedExpendData.innerYesterdayExpendAccountCount || 0), 1),
                  _createElementVNode("span", _hoisted_149, "外部: " + _toDisplayString($setup.animatedExpendData.outerYesterdayExpendAccountCount || 0), 1)
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_150, [
        _createElementVNode("div", _hoisted_151, null, 512)
      ])
    ])
  ]))
}